<template>
    <div>
        <template v-if="!consultorio || !filtro.paciente">
            <div class="form-row">
                <div class="col col-12 col-md-6">
                    <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                </div>
                <div class="col col-12 col-md-6">
                    <az-input   
                        type="select"
                        :optionsList="$util.unidades_com_tags(false, true)"
                        optionsData="id_unidade_operacao"
                        icon="fa fa-building-o fa-fw"
                        placeholder="Unidades..."
                        v-model="filtro.id_unidade_operacao" />
                </div>
            </div>

            <div class="form-row mt-2">
                <div class="col col-12 col-md-6">
                    <az-input 
                        icon="fa-solid fa-user-injured"
                        placeholder="Selecionar paciente..."
                        type="autocomplete" 
                        optionsMode="aql"
                        service="pacientes.index"
                        optionsDisplay="search"
                        ref="info_paciente"
                        v-model="filtro.paciente" 
                        :optimized_ac="true" />
                </div>
                <div class="col col-12 col-md-6">
                    <az-input 
                        icon="fa fa-search"
                        placeholder="Pesquisar..."
                        v-model="filtro.search" />
                </div>
            </div>
        </template>

        <template v-else>
            <az-input 
                icon="fa-solid fa-user-injured"
                :edicao="false"
                v-model="filtro.paciente.st_nome" />
        </template>

        <div class="progress mt-1 mb-2" v-if="lista.length">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <table class="table table-sm border-0 table-responsive" v-if="lista_classes && lista_classes.length">
            <tr>
                <td class="text-nowrap">
                    <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                        <span class="badge badge-success mr-1" >
                            {{ classe }}
                        </span>
                    </a>
                </td>
            </tr>
        </table>

        <az-empty-state class="mt-3" v-if="!lista.length" msg="Nenhum orçamento identificado." icon="fas fa-file-invoice-dollar" />

        <template v-else>
            <div class="row">
                <div class="col col-12">
                    <span class="badge badge-secondary" title="Quantidade de orçamentos encontrados.">
                        {{ dados.total }}
                    </span>
                </div>
            </div>

            <div class="list-group">
                <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(orc, iox) in lista" :key="iox" @click="selecionar_orcamento(orc)" :disabled="$store.state.loading">
                    <div>
                        <div class="lead">
                            <span v-if="orc.id_paciente" class="text-primary mr-2">
                                <i class="fa-solid fa-id-badge"></i>
                            </span>
                            <span v-else class="text-muted mr-2">
                                <i class="fa-solid fa-id-badge"></i>
                            </span>

                            {{ orc.st_titulo }}
                            
                            <span class="badge badge-danger ml-1" v-if="orc.fl_ativo === false">Inativo</span>

                            <div v-if="orc.js_classes && orc.js_classes.length">
                                <span class="badge badge-success mr-1" v-for="(classe, icx) in orc.js_classes" :key="icx">
                                    {{ classe }}
                                </span>
                            </div>
                        </div>
                        <div>
                            #{{ orc.id_orcamento }}
                            <span v-if="orc.created_at">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ $util.getFormatDate(orc.created_at.substr(0,10)) }}
                            </span>
                            <span v-if="orc.usuario && orc.usuario.st_login">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ orc.usuario.st_login }}
                            </span>
                            <span v-if="orc.plano">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ orc.plano.search }}
                            </span>
                            <span v-if="orc.unidade_operacao">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                <span class="badge badge-light" v-if="orc.unidade_operacao.st_sigla">
                                    {{ orc.unidade_operacao.st_sigla }}
                                </span>
                                <span v-else>
                                    {{ orc.unidade_operacao.st_nome }}
                                </span>
                            </span>

                            <span v-if="orc.st_email">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ orc.st_email }}
                            </span>

                            <span v-if="orc.st_celular">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ $util.formatMask(orc.st_celular, orc.st_celular.length == 10 ? 'tel' : 'cel') }}
                            </span>
                        </div>
                    </div>
                    <div class="text-right">
                        <div>
                            {{ $util.formatMoeda(orc.valor_final) }}
                        </div>
                        <span class="badge badge-dark mr-1" v-if="orc.id_pagamento_atendimento">
                            Pagamento Registrado
                        </span>
                        <span class="badge badge-primary" v-if="false">
                            {{ orc.js_procedimentos.length }}
                        </span>
                    </div>
                </button>
                <li class="list-group-item" v-if="dados.last_page > 1">...</li>
            </div>

        </template>

        <pre v-if="false">{{ dados }}</pre>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            dados: null, 
            filtro: { 
                orcamento: true, 
                periodo: 'do',
                id_unidade_operacao: "", 
                search: "", 
            },
            page: 1, 
        };
    },

    computed: { 
        lista_classes: function () { 
            if ( !this.dados || !this.dados.data ) { 
                return [];
            }

            return _.uniq(
                this.dados.data.filter(item => item.js_classes)
                    .flatMap(item => item.js_classes)
                    .sort()
            );
        },

        consultorio: function () { 
            return this.$route.name == 'corcamento';
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            return this.dados.data; 
        }
    },

    components: { 
        AzInput, 
        AzPeriodo, 
        AzEmptyState, 
    }, 

    props: ['paciente'], 

    methods: { 
        filtrar (texto) { 
            if ( this.filtro.search == '"' + texto + '"' ) { 
                this.filtro.search = "";
            } else { 
                this.filtro.search = '"' + texto + '"';
            }

            this.load();
        },

        abrir_perfil(orc) { 
            $('.modal').modal('hide');

            this.$nextTick(() => { 
                this.$root.perfil({ id_pessoa: orc.id_paciente });
            });
        },

        reset () { 
            this.dados = null;
        },

        load() { 
            this.$util.load(this, { 
                service: 'orcamentos',
                parms: { 
                    ...this.filtro, 
                    size: 100,
                    page: 1, 
                }
            });
        },

        selecionar_orcamento (orc) { 
            this.$util.load(this, { 
                service: 'orcamentos',
                func: 'show', 
                parms: {  
                    id: orc.id_orcamento, 
                    sel_orcamento: true, 
                },
                loadTo: res => { 
                    this.$emit('selecionado', res);
                }
            });
        }
    },

    beforeMount() { 
        console.log('buscar', this.paciente);

        if ( this.paciente ) { 
            this.filtro.paciente = this.paciente;
        }
    },

    mounted() { 

        if ( this.filtro.paciente ) { 
            this.load();
        }

    },
}
</script>